import { render, staticRenderFns } from "./FreightBillMethod.vue?vue&type=template&id=12fee0b7"
import script from "./FreightBillMethod.vue?vue&type=script&lang=js"
export * from "./FreightBillMethod.vue?vue&type=script&lang=js"
import style0 from "./FreightBillMethod.vue?vue&type=style&index=0&id=12fee0b7&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12fee0b7')) {
      api.createRecord('12fee0b7', component.options)
    } else {
      api.reload('12fee0b7', component.options)
    }
    module.hot.accept("./FreightBillMethod.vue?vue&type=template&id=12fee0b7", function () {
      api.rerender('12fee0b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/FreightBillMethod.vue"
export default component.exports